export const colors = {
  primary: '#003DA5',
  primaryFade: {
    300: '#F9FBFF',
    500: '#bfd7ff',
  },
  accent: '#B91C1C',
  white: '#ffffff',
  gray: {
    100: '#f1f1f1',
    200: '#ccc',
    300: '#e3e3e3',
    400: '#d1d1d1',
    425: '#7D7D7D',
    450: '#656565',
    500: '#696A6C',
    600: '#848484',
    700: '#4d4d4d',
    800: '#272A30',
  },
};
